<script setup lang="ts">

import {DotLottieVue} from "@lottiefiles/dotlottie-vue";
</script>

<template>
  <router-link to="/patient-administration/communication/message/store">
    <DotLottieVue style="height: 300px" :loop="false" autoplay src="animations/sad-bank-card.json" />
    <div class="flex flex-row items-center">
      <p class="flex-1">
        Vous n'avez pas suffisamment de crédit. Veuillez <span class="text-primary font-bold">recharger vos crédits SMS</span>
        dans le module relation patients.
      </p>
      <img class="ml-4 w-20 h-20" src="@/assets/images/sms-premium.png" alt="SMS premium">
    </div>
  </router-link>
</template>

<style scoped>

</style>
